import React from "../../__compat__/react/main.entry.mjs.mjs";
import { audiLightTheme } from "../../themes/index.mjs.mjs";
import { ThemeProvider } from "../ThemeProvider/index.mjs.mjs";
import { GlobalStyles } from "../GlobalStyles/index.mjs.mjs";
export const AudiPlatformProvider = ({ theme = audiLightTheme, fontUrl, iconFontUrl, children }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(GlobalStyles, { fontUrl: fontUrl, iconFontUrl: iconFontUrl }),
        React.createElement(ThemeProvider, { theme: theme }, children)));
};
//# sourceMappingURL=PlatformProvider.mjs.mjs.map